<mat-accordion id="{{id}}" multi>
  <mat-expansion-panel [expanded]="active">
    <mat-expansion-panel-header style="border-bottom: 1px solid #e0e0e1 !important;">
      <mat-panel-title>
        <strong>{{title}}</strong>
      </mat-panel-title>

    </mat-expansion-panel-header>

    <div class="mt-4">
      <ng-content></ng-content>

    </div>

  </mat-expansion-panel>

</mat-accordion>
<br>
